var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallenderSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.666 6.16797V15.418",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.334 6.16797V15.418",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.791 28.0273H63.2077",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8327 58.5833C67.8327 60.8958 67.1852 63.085 66.0443 64.935C63.9168 68.5117 60.001 70.9167 55.4993 70.9167C52.3852 70.9167 49.5485 69.7758 47.3902 67.8333C46.4344 67.0317 45.6019 66.045 44.9544 64.935C43.8135 63.085 43.166 60.8958 43.166 58.5833C43.166 51.7692 48.6852 46.25 55.4993 46.25C59.1993 46.25 62.4985 47.8841 64.7494 50.4433C66.661 52.6325 67.8327 55.4692 67.8327 58.5833Z",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6895 58.5842L53.7419 61.6367L60.3094 55.5625",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75 26.2096V50.4446C62.4992 47.8854 59.2 46.2513 55.5 46.2513C48.6858 46.2513 43.1667 51.7705 43.1667 58.5846C43.1667 60.8971 43.8142 63.0863 44.955 64.9363C45.6025 66.0463 46.435 67.033 47.3908 67.8346H24.6667C13.875 67.8346 9.25 61.668 9.25 52.418V26.2096C9.25 16.9596 13.875 10.793 24.6667 10.793H49.3333C60.125 10.793 64.75 16.9596 64.75 26.2096Z",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9857 42.2409H37.0134",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5736 42.2409H25.6013",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5736 51.4909H25.6013",
    stroke: "#37588A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallenderSvg);
export default __webpack_public_path__ + "static/media/callenderSvg.1eceba5c137c405accff55b2885ae286.svg";
export { ForwardRef as ReactComponent };